import { render, staticRenderFns } from "./issue_supply.vue?vue&type=template&id=56257f7e&scoped=true"
import script from "./issue_supply.vue?vue&type=script&lang=js"
export * from "./issue_supply.vue?vue&type=script&lang=js"
import style0 from "./issue_supply.vue?vue&type=style&index=0&id=56257f7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56257f7e",
  null
  
)

export default component.exports